import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleCommentEvaluer() {
  return (
    <BlogArticleLayout
      tag="Audit & Diagnostic"
      title="Comment évaluer la cybersécurité de votre PME"
      date="22 septembre 2026"
      ctaTitle="Passez de l'auto-évaluation au diagnostic complet"
      ctaText="Le diagnostic gratuit reprend ces quatre dimensions et vous donne un score précis, sans avoir à tout évaluer vous-même."
    >
      <p style={s.intro}>
        Avant de se lancer dans un audit formel, un dirigeant peut déjà se faire une première idée de la
        situation de son entreprise. Voici les quatre dimensions à regarder, et les questions simples qui
        permettent de se situer sans expertise technique.
      </p>

      <h2 style={s.h2}>1. La dimension technique</h2>
      <p>
        Sans entrer dans le détail des systèmes, quelques questions suffisent à donner une première
        indication : vos accès aux outils sensibles sont-ils protégés par des mots de passe uniques et
        robustes ? Vos sauvegardes sont-elles automatiques, régulières, et avez-vous déjà vérifié qu'elles
        peuvent réellement être restaurées ? Vos logiciels et systèmes sont-ils mis à jour, ou certains
        tournent-ils depuis des années sans correctif ?
      </p>

      <h2 style={s.h2}>2. La dimension organisationnelle</h2>
      <p>
        Existe-t-il une procédure écrite, même simple, en cas d'incident (qui prévenir, dans quel ordre, avec
        quelles coordonnées) ? Savez-vous précisément qui, dans votre entreprise, a accès à quelles données
        et pourquoi ? Ces accès sont-ils révisés lorsqu'un salarié change de poste ou quitte l'entreprise ?
      </p>

      <h2 style={s.h2}>3. La dimension humaine</h2>
      <p>
        Vos équipes ont-elles déjà reçu une sensibilisation, même courte, aux tentatives de phishing ?
        Sauraient-elles reconnaître un email frauduleux imitant un fournisseur ou une demande de virement
        inhabituelle ? La majorité des incidents cybersécurité commencent encore par une erreur humaine plutôt
        que par une faille technique complexe — c'est souvent la dimension la plus sous-estimée.
      </p>

      <h2 style={s.h2}>4. La dimension tiers et prestataires</h2>
      <p>
        Savez-vous quels prestataires ont accès à vos données ou à vos systèmes (hébergeur, logiciel de
        comptabilité, agence marketing) ? Avez-vous une visibilité, même approximative, sur leurs propres
        pratiques de sécurité ? Une entreprise bien protégée en interne reste exposée si un de ses
        prestataires ne l'est pas.
      </p>

      <h2 style={s.h2}>Ce que cette auto-évaluation ne permet pas de faire</h2>
      <p>
        Répondre honnêtement à ces questions donne déjà une intuition de votre niveau de maturité. Mais une
        intuition n'est pas un score, et encore moins un plan d'action priorisé. C'est tout l'intérêt d'un
        diagnostic structuré, qui reprend ces mêmes dimensions de façon exhaustive et les traduit en actions
        concrètes — voir notre
        {' '}<Link to="/blog/diagnostic-cybersecurite-a-quoi-sattendre" style={s.link}>article sur le déroulement d'un diagnostic</Link>.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleCommentEvaluer;
